import { useAuth } from './auth';
import { isFeatureGranted } from '../utils/isFeatureGranted';

// Fininho de propósito: só embrulha `useAuth()` + `isFeatureGranted` pra
// call sites não repetirem `isFeatureGranted(user?.features?.code)`.
// Fonte da verdade continua sendo `user.features` (populado no GET
// /users) -- não busca nada por conta própria.
function useFeature(code: string): boolean {
  const { user } = useAuth();

  return isFeatureGranted(user?.features?.[code]);
}

export { useFeature };
